import styled from '@emotion/styled';
import { Trans } from 'react-i18next';
import { tokens, Text } from '@hotjar/hotsauce';
import type { Site } from '@hotjar/site';
import { TrackingCodeSnippet } from '@hotjar/webapp/features/Activation/TrackingCodeSnippet';
import { useSiteName } from '@hotjar/site';

const Paragraph = styled(Text)`
  margin-bottom: ${tokens.spacer.x2};
  border: red;

  b {
    font-weight: 600;
  }
`;

interface TrackingCodeTabProps {
  site: Site;
  onVerifyClick?: () => void;
}

export const TrackingCodeTab = ({
  site,
  onVerifyClick,
}: TrackingCodeTabProps): JSX.Element | null => {
  const siteName = useSiteName(site);

  return site ? (
    <>
      <Paragraph as="p" textType="body2" textColor="text_default">
        <Trans i18nKey="activation:tracking-code.installation.snippet-title" values={{ siteName }}>
          This tracking code is unique to <b>{siteName}</b>.
        </Trans>
      </Paragraph>
      <TrackingCodeSnippet site={site} onVerifyClick={onVerifyClick} />
    </>
  ) : null;
};
